module.exports = __webpack_public_path__ + "img/installAndroid1.8f193f2f.png";